import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useSearchParams } from "react-router-dom";
import Navbar from "../Navbar";
import Footer from "./Footer";
import SEO from "../components/SEO";

const API_URL = "https://backend-ged-immo.onrender.com";
// const API_URL = "http://localhost:8080"


export default function Louer() {
  const [searchParams] = useSearchParams();
  const [rentHomes, setRentHomes] = useState([]);
  const [items, setItems] = useState([]);
  const [filterOpen, setFilterOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState(searchParams.get("q") || "");

  const [filters, setFilters] = useState({
    type: "all",
    pieces: "all",
    city: "all",
    minRent: "",
    maxRent: "",
  });

  /* ================= FETCH ================= */
  useEffect(() => {
    axios.get(`${API_URL}/homes`)
      .then(res => {
        setRentHomes(res.data.homes || []);
        setItems(res.data.homes || []);
      })
      .finally(() => setLoading(false));
  }, []);

  /* ================= FILTRAGE ================= */
  useEffect(() => {
    let data = [...rentHomes];

    // Recherche textuelle (navbar ou barre locale)
    if (searchQuery.trim()) {
      const q = searchQuery.trim().toLowerCase();
      data = data.filter(h =>
        [h.nameHome, h.city, h.quarter, h.addressHome, h.nameHomeType, h.categorie, h.description]
          .filter(Boolean)
          .some(v => v.toLowerCase().includes(q))
      );
    }

    if (filters.type !== "all")
      data = data.filter(h => h.nameHomeType === filters.type);

    if (filters.pieces !== "all")
      data = data.filter(h => Number(h.NmbrePieces) === Number(filters.pieces));

    if (filters.city !== "all")
      data = data.filter(h => h.city === filters.city);

    if (filters.minRent)
      data = data.filter(h => h.rent >= Number(filters.minRent));

    if (filters.maxRent)
      data = data.filter(h => h.rent <= Number(filters.maxRent));

    setItems(data);
  }, [filters, rentHomes, searchQuery]);

  const updateFilter = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  function FilterForm({ filters, updateFilter, resetFilters }) {
  return (
    <>
      {/* TYPE */}
      <select
        value={filters.type}
        onChange={e => updateFilter("type", e.target.value)}
      >
        <option value="all">Tous les types</option>
        <option value="Appartement">Appartement</option>
        <option value="Villa Duplex">Villa Duplex</option>
        <option value="Villa Basse">Villa Basse</option>
        <option value="Bureau">Bureau</option>
        <option value="Magasin">Magasin</option>
      </select>

      {/* PIECES */}
      <select
        value={filters.pieces}
        onChange={e => updateFilter("pieces", e.target.value)}
      >
        <option value="all">Toutes les pièces</option>
        {[1,2,3,4,5,6,7,8,9,10].map(n => (
          <option key={n} value={n}>{n} pièces</option>
        ))}
      </select>

      {/* BUDGET */}
      <input
        type="number"
        placeholder="Budget min"
        value={filters.minRent}
        onChange={e => updateFilter("minRent", e.target.value)}
      />

      <input
        type="number"
        placeholder="Budget max"
        value={filters.maxRent}
        onChange={e => updateFilter("maxRent", e.target.value)}
      />

      {/* ACTIONS */}
      <button type="button" className="filter-btn">
        Appliquer
      </button>

      <button
        type="button"
        className="filter-btn reset-btn"
        onClick={resetFilters}
      >
        Réinitialiser
      </button>
    </>
  );
}

  const resetFilters = () => {
    setFilters({
      type: "all",
      pieces: "all",
      city: "all",
      minRent: "",
      maxRent: "",
    });
  };

  if (loading) {
    return <p style={{ padding: 60, textAlign: "center" }}>Chargement...</p>;
  }

  return (
    <>
      <SEO
        title="Biens à louer — Appartements & Villas"
        description="Trouvez votre logement idéal en location à Abidjan et en Côte d'Ivoire. Villas, appartements, bureaux proposés par SCI MAYEDO."
        canonical="/louer"
      />
      <Navbar />

      {/* ================= DESKTOP LAYOUT ================= */}

      <div className="container__real__header">
        <div className="container__real__header__content">
          <h2 className="md">LOCATION</h2>
          <h4>Quelques-unes de nos réalisations en location.</h4>
        </div>
      </div>

      {/* ── Barre de recherche rapide ── */}
      <div className="louer-search-bar">
        <form
          onSubmit={e => e.preventDefault()}
          className="louer-search-form"
        >
          <i className="fa-solid fa-magnifying-glass louer-search-icon"></i>
          <input
            type="text"
            className="louer-search-input"
            placeholder="Rechercher par ville, type, quartier, nom…"
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
          />
          {searchQuery && (
            <button
              type="button"
              className="louer-search-clear"
              onClick={() => setSearchQuery("")}
              aria-label="Effacer"
            >
              <i className="fa-solid fa-xmark"></i>
            </button>
          )}
        </form>
        {searchQuery && (
          <p className="louer-search-results">
            {items.length} résultat{items.length !== 1 ? "s" : ""} pour «&nbsp;{searchQuery}&nbsp;»
          </p>
        )}
      </div>

      <style>{`
        .louer-search-bar {
          max-width: 700px;
          margin: 1.5rem auto 0;
          padding: 0 1rem;
        }
        .louer-search-form {
          display: flex;
          align-items: center;
          gap: 10px;
          background: #fff;
          border: 2px solid #1B4F9E;
          border-radius: 50px;
          padding: 10px 20px;
          box-shadow: 0 4px 20px rgba(27,79,158,0.12);
        }
        .louer-search-icon { color: #1B4F9E; font-size: 1rem; flex-shrink: 0; }
        .louer-search-input {
          flex: 1;
          border: none;
          outline: none;
          font-size: 0.95rem;
          color: #0f1f3d;
          background: transparent;
        }
        .louer-search-input::placeholder { color: #9ca3af; }
        .louer-search-clear {
          background: none;
          border: none;
          color: #9ca3af;
          cursor: pointer;
          font-size: 0.9rem;
          padding: 0;
          display: flex;
          align-items: center;
        }
        .louer-search-clear:hover { color: #dc2626; }
        .louer-search-results {
          text-align: center;
          margin-top: 8px;
          font-size: 0.85rem;
          color: #5a6e8c;
        }
      `}</style>
         {/* ================= MOBILE FILTER BUTTON ================= */}
      <div className="filter-btn-mobile">
        <button className="filter-btn" onClick={() => setFilterOpen(true)}>
          Filtrer
        </button>
      </div>

      {/* ================= MOBILE FILTER ================= */}
      <div className={filterOpen ? "filter__bar show__filter__bar" : "filter__bar"}>
        <div className="filter__bar__content">
          <div className="filter-header">
            <h4 className="filter-title">Filtres</h4>
            <button className="close-btn" onClick={() => setFilterOpen(false)}>
              ✕
            </button>
          </div>
          <FilterForm filters={filters} updateFilter={updateFilter} resetFilters={resetFilters} />
        </div>
      </div>

      <div className="layout">
        <div className="filter-desktop">
          <h4 className="filter-title">Filtres</h4>
          <FilterForm filters={filters} updateFilter={updateFilter} resetFilters={resetFilters} />
        </div>

        <div className="cards-grid">
          {items.map(item => (
           <div key={item._id} className="cards">
  <Link to={`/details/${item._id}`} className="card-image-wrapper">
    <img
      src={
        item.img
          ? item.img.startsWith("http")
            ? item.img
            : `${API_URL}/${item.img}`
          : "/no-image.png"
      }
      alt={item.nameHome}
    />

    {/* 🔴🟢 BADGE STATUT */}
   <span
  className={`status-badge ${
    item.state === "Disponible" ? "available" : "occupied"
  }`}
>
  {item.state}
</span>
  </Link>

  <div className="cards-content">
    <strong>{item.nameHome}</strong>
    <p>{item.city}</p>
    <p>{item.addressHome}</p>
    <p>Nombre de pièces : {item.NmbrePieces}</p>
    <p className="price">
      {item.rent?.toLocaleString()} FCFA / mois
    </p>
  </div>
</div>
          ))}
        </div>
      </div>

      <Footer />
       {/* ================= STYLE EMBARQUÉ ================= */}
      <style>{`
        :root {
  --primary: #2563eb;
  --secondary: rgb(12, 52, 103);
  --bg: #f8fafc;
}

/* ================= LAYOUT ================= */
.layout {
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 25px;
  padding: 30px;
  background: var(--bg);
}

/* ================= FILTER ================= */
.filter-desktop,
.filter__bar__content {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0,0,0,.08);
}

.filter-title {
  color: var(--primary);
  margin-bottom: 15px;
}

.filter-desktop select,
.filter-desktop input,
.filter__bar__content select,
.filter__bar__content input {
  width: 100%;
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  margin-bottom: 12px;
}

.filter-btn {
  width: 100%;
  padding: 10px;
  border-radius: 6px;
  border: none;
  background: var(--secondary);
  color: #fff;
  cursor: pointer;
}

.reset-btn {
  background: #ef4444;
  margin-top: 8px;
}

/* ================= CARDS GRID ================= */
.cards-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.8rem;
}
/* ================= STATUS BADGE ================= */
.card-image-wrapper {
  position: relative;
  display: block;
}

.status-badge {
  position: absolute;
  top: 12px;
  left: 12px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 20px;
  color: #fff;
  z-index: 2;
  box-shadow: 0 4px 10px rgba(0,0,0,.25);
}

/* 🟢 Disponible */
.status-badge.available {
  background: #16a34a;
}

/* 🔴 Occupé */
.status-badge.occupied {
  background: #dc2626;
}
.cards {
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 8px 20px rgba(0,0,0,.08);
  transition: .3s;
}

.cards:hover {
  transform: translateY(-4px);
}

.cards img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.cards-content {
  padding: 16px;
}

.price {
  color: var(--secondary);
  font-weight: bold;
}

/* ================= MOBILE FILTER ================= */
.filter-btn-mobile {
  display: none;
  text-align: center;
  padding: 15px;
}

.filter__bar {
  position: fixed;
  top: 0;
  right: -330px;
  width: 320px;
  height: 100vh;
  background: #fff;
  transition: .3s;
  z-index: 999;
  box-shadow: -6px 0 20px rgba(0,0,0,.2);
}

.show__filter__bar {
  right: 0;
}

.filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
}

/* ================= RESPONSIVE ================= */

/* 📱 MOBILE */
@media (max-width: 640px) {
  .layout {
    grid-template-columns: 1fr;
    padding: 15px;
  }

  .filter-desktop {
    display: none;
  }

  .filter-btn-mobile {
    display: block;
  }

  .cards-grid {
    grid-template-columns: 1fr;
  }

  .cards img {
    height: 170px;
  }
}

/* 📱➡️📱 TABLET */
@media (min-width: 641px) and (max-width: 1024px) {
  .layout {
    grid-template-columns: 1fr;
  }

  .filter-desktop {
    display: none;
  }

  .filter-btn-mobile {
    display: block;
  }

  .cards-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* 💻 LAPTOP */
@media (min-width: 1025px) and (max-width: 1280px) {
  .cards-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* 🖥️ DESKTOP LARGE */
@media (min-width: 1281px) {
  .cards-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}
      `}</style>
    </>
  );
}
